import { StylesConfig } from "react-select"
import { ISelectOption } from "@/app/types/types"

export const selectStyles: StylesConfig<ISelectOption, false> = {
	menu: (provided) => ({
		...provided,
		backgroundColor: "rgba(14, 34, 62, 0.8)",
		color: "#fff",
		padding: "0",
		zIndex: 9999,
		overflow: "hidden",
		border: "1px solid rgba(255, 255, 255, 0.1)",
	}),
	menuList: (provided) => ({
		...provided,
		padding: 0,
		maxHeight: "150rem",
		scrollbarWidth: "none",
		overflowY: "auto",
	}),
	control: (provided, state) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.1)",
		boxShadow: "none",
		minHeight: "3.75rem",
		transition: "1s all",
		zIndex: "1",
		cursor: "pointer",
		padding: "1rem",
		borderRadius: "1.875rem",
		border: "2px solid transparent",
		"&:hover": {
			borderColor: "transparent",
		},
		opacity: state?.isDisabled ? "0.5" : "1",
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: state?.isDisabled ? "rgba(255, 255, 255, 0.5)" : "white",
		margin: 0,
		overflow: "unset",
		fontSize: "1.125rem",
	}),
	placeholder: (provided) => ({
		...provided,
		color: "rgba(255, 255, 255, 0.5)",
		fontSize: "1.125rem",
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		color: "rgba(255, 255, 255, 0.60)",
		padding: 0,
		fontSize: "1.5rem",
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		display: "none",
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0",
		height: "100%",
	}),
	option: (provided, state) => ({
		...provided,
		cursor: "pointer",
		fontSize: ".9em",
		backgroundColor:
			state.isSelected || state.isFocused
				? "rgba(14, 34, 62, 1)"
				: "rgba(14, 34, 62, 0.60)",
		"&:active": {
			backgroundColor: "rgba(14, 34, 62, 0.30)",
		},
		"&:hover": {
			backgroundColor: "white",
			color: "#0E223E",
		},
	}),
	input: (provided) => ({
		...provided,
		color: "white",
		textTransform: "uppercase",
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.2)",
		fontSize: "1.2rem",
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: "white",
		paddingInline: "0.75rem",
	}),
	multiValueRemove: (provided) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.2)",
		"&:hover": {
			backgroundColor: "#636363",
			color: "white",
		},
	}),
}

export const errorStyles: StylesConfig<ISelectOption, false> = {
	control: (provided) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.1)",
		boxShadow: "none",
		minHeight: "3.75rem",
		transition: "1s all",
		zIndex: "1",
		cursor: "pointer",
		padding: "1rem",
		border: "2px solid rgb(255, 10, 10)",
		borderRadius: "1.875rem",
		// "&:hover": {
		// 	borderColor: "transparent",
		// },
	}),
	menu: (provided) => ({
		...provided,
		backgroundColor: "rgba(14, 34, 62, 0.8)",
		color: "#fff",
		padding: "0",
		zIndex: "2",
		overflow: "hidden",
		border: "1px solid rgba(255, 255, 255, 0.1)",
	}),
	menuList: (provided) => ({
		...provided,
		padding: 0,
		maxHeight: "150px",
		scrollbarWidth: "none",
		overflowY: "auto",
	}),

	singleValue: (provided, state) => ({
		...provided,
		color: state?.isDisabled ? "rgba(255, 255, 255, 0.5)" : "white",
		margin: 0,
		overflow: "unset",
		fontSize: "1.125rem",
	}),
	placeholder: (provided) => ({
		...provided,
		color: "rgb(255, 10, 10)",
		fontSize: "1.125rem",
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		color: "rgb(255, 10, 10)",
		padding: 0,
		fontSize: "1.5rem",
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		display: "none",
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0",
		height: "100%",
	}),
	option: (provided, state) => ({
		...provided,
		cursor: "pointer",
		fontSize: ".9em",
		backgroundColor:
			state.isSelected || state.isFocused
				? "rgba(14, 34, 62, 1)"
				: "rgba(14, 34, 62, 0.60)",
		"&:active": {
			backgroundColor: "rgba(14, 34, 62, 0.30)",
		},
	}),
	input: (provided) => ({
		...provided,
		color: "white",
		textTransform: "uppercase",
	}),
	multiValue: (provided) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.2)",
		fontSize: "1.2rem",
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: "white",
		paddingInline: "0.75rem",
	}),
	multiValueRemove: (provided) => ({
		...provided,
		backgroundColor: "rgba(255, 255, 255, 0.2)",
		"&:hover": {
			backgroundColor: "#636363",
			color: "white",
		},
	}),
}

export const filterStyles: StylesConfig<ISelectOption, false> = {
	menu: (provided) => ({
		...provided,
		backgroundColor: "rgba(255,255,255)",
		color: "#fff",
		padding: "0",
		zIndex: "2",
		overflow: "hidden",
	}),
	menuList: (provided) => ({
		...provided,
		padding: 0,
		maxHeight: "150px",
		scrollbarWidth: "none",
		overflowY: "auto",
		background: "#000",
		opacity: "1",
	}),
	control: (provided) => ({
		...provided,
		backgroundColor: "rgba(0, 0, 0, 0.05)",
		boxShadow: "none",
		minHeight: "3.75rem",
		transition: "1s all",
		zIndex: "1",
		cursor: "pointer",
		padding: "1rem",
		borderRadius: "4rem",
		border: "2px solid transparent",
		"&:hover": {
			borderColor: "transparent",
		},
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: "#000",
		margin: 0,
		overflow: "unset",
		fontSize: "1.125rem",
	}),
	placeholder: (provided) => ({
		...provided,
		color: "rgba(0,0,0, 0.60)",
		fontSize: "1.125rem",
		fontWeight: "600",
	}),
	dropdownIndicator: (provided, state) => ({
		...provided,
		color: "rgba(0,0,0, 0.60)",
		padding: 0,
		fontSize: "1.5rem",
	}),
	indicatorSeparator: (provided) => ({
		...provided,
		display: "none",
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0",
		height: "100%",
	}),
	option: (provided, state) => ({
		...provided,
		cursor: "pointer",
		fontSize: ".9em",
		backgroundColor: "rgba(255,255,255, 0.60)",
		"&:active": {
			backgroundColor: "red",
		},
		"&:hover": {
			backgroundColor: "#091A32",
		},
	}),
	input: (provided) => ({
		...provided,
		color: "white",
		textTransform: "uppercase",
	}),
}
